import { LiturgyHomeData } from "@/models/LiturgyHomeData";

export const useLiturgyStore = defineStore("liturgy", () => {
  const api = useApiStore();
  const debug = useDebug();

  const homeData = ref<LiturgyHomeData>({
    data: [],
    minIndex: 0,
    maxIndex: 0,
    enableSectionResponsorialPsalms: false,
    enableSectionMassSettings: false,
    enableSectionLiturgyAndMass: false,
    availableMassSettingCategories: [],
  });

  async function getHomeData(index: number | null, numPerPage: number) {
    debug.log("home data", index);

    homeData.value = await api.post("/GetLiturgyHomeData", {
      startingAtIndex: index === null ? -1 : index,
      numPerPage: numPerPage,
    });

    availableMassSettings.value =
      homeData.value.availableMassSettingCategories || [];
  }

  const availableMassSettings = ref<string[] | null>(null);

  return {
    homeData,
    getHomeData,
    availableMassSettings,
  };
});
